import React from 'react';
import PropTypes from 'prop-types';

class UserWelcomeContainer extends React.Component {

  render() {
    return (
      <div className="user-welcome-container" >
        <div className="user-welcome-container__header-banner">
          <div className="user-welcome-container__header-banner__text-banner">
            <p> { new Date().getHours() < 12 ? 'Good Morning' : 'Welcome'}, <span> {this.props.userInformation.firstName + ' '+  this.props.userInformation.lastName }. </span> </p>
          </div>
        </div>
      </div>
    );
  }
}

UserWelcomeContainer.propTypes = {
  userInformation: PropTypes.object.isRequired
};

export default UserWelcomeContainer;



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/userWelcome/UserWelcomeContainer.js